export const version = 'berater-v1.19.0-SNAPSHOT-07187d28bdd33405200a4dc4d0129ea0d2c18725';